import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useTranslation } from "react-i18next";
import { } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import StandartPage from '../Layouts/Shared/_StandartPage';
import CompDtMoneyTransfer from '../Components/MoneyTransferList/CompDtMoneyTransfer';

export default function MoneyTransferList() {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [seed, setSeed] = useState(0);
    const [data, setData] = useState(null);

    return (
        <StandartPage title={t('pages.money-transfers.title')} >
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <Col className="col-12 p-2 container">
                        <CompDtMoneyTransfer />
                    </Col>
                </Row>
            </React.Fragment>
        </StandartPage>
    )

}